<script>
  export default {
    name: 'back-button',
    props: {
      size: {
        default: 'medium',
        type: String
      },
      text: {
        default: 'Voltar',
        type: String
      },
      icon: {
        default: 'fa fa-arrow-left',
        type: String
      }
    },
    methods: {
      goBack () {
        this.$router.go(-1)
      }
    }
  }
</script>

<template>
    <el-button :size="size" @click="goBack()">
        <i v-bind:class="icon"></i>
        <span>{{text}}</span>
    </el-button>
</template>



// WEBPACK FOOTER //
// BackButton.vue?20758ed2